"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputWithIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

var _Input = _interopRequireDefault(require("../Input"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "container": "tcl__InputWithIcon-dc3edaf1",
  "icon": "tcl__InputWithIcon-7ea37bb9",
  "small": "tcl__InputWithIcon-a47d8cd9",
  "medium": "tcl__InputWithIcon-7531bd6a",
  "input": "tcl__InputWithIcon-22647c62"
};
const iconSizes = {
  small: 18,
  medium: 24
};

const InputWithIcon = ({
  type = 'text',
  icon,
  iconColor,
  className,
  isValid,
  size,
  ...props
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)(styles.container, className)
}, /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: icon,
  color: iconColor,
  className: (0, _classnames.default)(styles.icon, styles[size]),
  size: iconSizes[size]
}), /*#__PURE__*/_react.default.createElement(_Input.default, _extends({}, props, {
  type: type,
  size: size,
  className: (0, _classnames.default)(styles.input, styles[size]),
  isValid: isValid
})));

exports.InputWithIcon = InputWithIcon;
InputWithIcon.displayName = "InputWithIcon";
InputWithIcon.propTypes = { ..._withSpacing.propTypes,
  className: _propTypes.default.string,
  icon: _propTypes.default.string.isRequired,
  iconColor: _propTypes.default.oneOf(['black', 'white', 'grey', 'light-grey', 'teal', 'dark-teal', 'green', 'orange', 'red', 'inherit']),
  isValid: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['email', 'number', 'password', 'search', 'tel', 'text', 'url']).isRequired,
  size: _propTypes.default.oneOf(['small', 'medium'])
};
InputWithIcon.defaultProps = {
  className: '',
  isValid: true,
  size: 'small',
  iconColor: 'light-grey'
};

var _default = (0, _withSpacing.default)(InputWithIcon);

exports.default = _default;